import { useCallback, useEffect } from "react";
import Header from "../../landingPage/Header";
import { Link, Outlet, useLocation } from "react-router-dom";
import Footer from "../../landingPage/Footer";
import { FaGreaterThan } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { fetchParentsStudents } from "../../../redux/features/parentStudentsSlice";
import { auth, authMobile } from "../../../config/firebaseConfig";

const ParentDashboardLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const candidateId = location.pathname.split("/")[2];
  const isAiLabPath = location.pathname.includes("/parentDashboard/ai-lab");
  const aiLabStep = location.pathname.split("/").pop();
  
  let stepLabel = "";
  if (aiLabStep === "enrol") stepLabel = "Enrol";
  else if (aiLabStep === "step1") stepLabel = "Child Details";
  else if (aiLabStep === "step2") stepLabel = "Courses";
  else if (aiLabStep === "step3") stepLabel = "Schedule";
  else if (aiLabStep === "step4") stepLabel = "Payment";

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const { userDetails: parentsDetails } = useSelector((state) => state.auth);

  // fetch participants registered for the school
  const fetchStudents = useCallback(() => {
    try {
      parentsDetails &&
        dispatch(fetchParentsStudents({ parentUid: parentsDetails?.uid }))
          .unwrap()
          .catch((error) => {
            throw new Error(error.message);
          });
    } catch (err) {
      console.log(err);
    }
  }, [dispatch, parentsDetails]);

  useEffect(() => {
    const unsub = parentsDetails ? fetchStudents() : () => { };
    return () => unsub?.();
  }, [parentsDetails, fetchStudents]);

  return (
    <div>
      <Header placement="dashboard" dashboard="parent" />
      <div className="parents-dashbaord">
        <div className="banner-back bg-[#001E3B]">
          <div className="container flex justify-center py-5">
            {isAiLabPath ? (
              <div className="left-item text-white">
                <p className="text-lg flex items-center">
                  <Link to="/parentDashboard" className="text-white underline">
                    Dashboard
                  </Link>
                  <span className="mx-2">
                    <FaGreaterThan className="w-4 h-4" />
                  </span>
                  {stepLabel ? (
                    <>
                      <Link to="/parentDashboard/ai-lab" className="text-white underline">
                        AI-Lab
                      </Link>
                      <span className="mx-2">
                        <FaGreaterThan className="w-4 h-4" />
                      </span>
                      <span className="font-bold">{stepLabel}</span>
                    </>
                  ) : (
                    <span className="font-bold">AI-Lab</span>
                  )}
                </p>
              </div>
            ) : candidateId ? (
              <div className="left-item text-white">
                <p className="text-lg flex items-center">
                  <Link to="/parentDashboard" className="text-white underline">
                    Dashboard
                  </Link>
                  <span className="mx-2">
                    <FaGreaterThan className="w-4 h-4" />
                  </span>
                  <span className="font-bold">Student Details</span>
                </p>
              </div>
            ) : (
              <div className="left-item text-white space-y-4 text-center">
                <h1 className="text-4xl font-bold">Welcome Parents!</h1>
                {/* <p className="text-lg">
                  Take a moment to explore this dashboard and download resources
                  to help your child prepare for the{" "}
                  <strong>PRACTIDO Online Olympiad 2024</strong>.
                </p> */}
              </div>
            )}

            {/* <div className="right-item">
              <img
                className="banner-cloud"
                src="/img/new-home/cloud-banner-common.png"
                alt="banner"
              />
            </div> */}
          </div>
        </div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default ParentDashboardLayout;
